import type { RoofvizFixture, XY } from "../roofviz/contract.ts";

// Narwee reference reconstruction: verified AppliCad plan topology, measured 26.6° pitch,
// and a clearly labelled assumed 2.7 m eave datum. No roof objects or rear-building geometry.
const A: XY = [0, 8.586];
const B: XY = [12.802, 8.586];
const C: XY = [12.802, 0];
const D: XY = [1.666, 0];
const E: XY = [1.666, 3.753];
const F: XY = [0, 3.753];
const P: XY = [2.4165, 6.1695];
const Q: XY = [4.0825, 6.1695];
const R: XY = [5.959, 4.293];
const S: XY = [8.509, 4.293];

export const NARWEE_FIXTURE: RoofvizFixture = {
  id: "narwee",
  packet: {
    packet: "roofviz_packet_v1",
    property: {
      label: "60 Penshurst Road, Narwee NSW 2209",
      suburb: "Narwee NSW 2209",
      trackingId: "264759689702",
    },
    units: "meters",
    crs: "local_xy_meters",
    levels: [{ id: "L1", name: "Main roof", eaveHeightM: 2.7 }],
    planes: [
      { id: "top", levelId: "L1", ring: [A, B, S, R, Q, P], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
      { id: "right", levelId: "L1", ring: [B, C, S], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
      { id: "bottom", levelId: "L1", ring: [C, D, R, S], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
      { id: "lower-left", levelId: "L1", ring: [D, E, Q, R], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
      { id: "notch", levelId: "L1", ring: [E, F, P, Q], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
      { id: "left", levelId: "L1", ring: [F, A, P], pitchDeg: 26.6, pitchSource: "measured", eaveEdge: [0, 1] },
    ],
    lines: [
      { class: "ridge", polyline: [P, Q], planeIds: ["top", "notch"] },
      { class: "ridge", polyline: [R, S], planeIds: ["top", "bottom"] },
      { class: "valley", polyline: [E, Q], planeIds: ["notch", "lower-left"] },
      { class: "hip", polyline: [A, P], planeIds: ["top", "left"] },
      { class: "hip", polyline: [F, P], planeIds: ["notch", "left"] },
      { class: "hip", polyline: [Q, R], planeIds: ["top", "lower-left"] },
      { class: "hip", polyline: [D, R], planeIds: ["bottom", "lower-left"] },
      { class: "hip", polyline: [B, S], planeIds: ["top", "right"] },
      { class: "hip", polyline: [C, S], planeIds: ["bottom", "right"] },
      { class: "eave", polyline: [A, B], planeIds: ["top"] },
      { class: "eave", polyline: [B, C], planeIds: ["right"] },
      { class: "eave", polyline: [C, D], planeIds: ["bottom"] },
      { class: "eave", polyline: [D, E], planeIds: ["lower-left"] },
      { class: "eave", polyline: [E, F], planeIds: ["notch"] },
      { class: "eave", polyline: [F, A], planeIds: ["left"] },
    ],
    objects: [],
    aggregates: {
      planAreaM2: 103.665474,
      surfaceAreaM2: 115,
      storeys: 1,
      ridgeM: 4.22,
      hipM: 29.38,
      valleyM: 3.625,
      eaveM: 42.778,
    },
  },
  footprints: [{ pts: [A, B, C, D, E, F], h: 2.7 }],
  assumedHeights: true,
  note: "Reference reconstruction from the Narwee AppliCad report. Roof pitch is measured; the 2.7 m eave height is assumed for visualisation.",
};
